//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CategoriesGrid from '../components/CategoriesGrid'
import IntSlides from '../components/IntSlides'
// import BreadCrumbs from '../components/BreadCrumbs'
export default {
  auth: false,
  components: {
    // BreadCrumbs,
    CategoriesGrid,
    IntSlides
  },
  data () {
    return {
      topSlides: [
        {
          title: '',
          img: 'slider2.jpg'
        },
        {
          title: '',
          img: 'slider.jpg'
        }
      ]
    }
  },
  head: {
    title: 'Nuestros Catálogos',
    meta: [
      { hid: 'og:title', name: 'og:title', content: 'Nuestros Catálogos' },
      { hid: 'description', name: 'description', content: 'Nuestros Catálogos' }
    ]
  }
}
